export const scrollToTop = () => {
    window.scrollY > 190 &&
        scrollBy({
            /*  We are using static values because we know the height of the navigation  or the filtertoolbar won't change */
            top: -window.scrollY + 140,
            behavior: "smooth",
        });
};
